@let editingNode = editingNodeSg();

@if (editingNode) {
  <div class="atn-summit-org-chart-node-panel-general-tab">
    @for (attr of nodeAttributesSg(); track $index) {
      @let partialId = attributeIdToPartialIdMap()[attr.id];
      @if (partialId) {
        <atn-display-value
          [label]="attr.name"
          [type]="attr.type"
          [value]="editingNode.values?.[partialId]"
          (valueChange)="onValueChange(attr.id, $event)"
        />
      } @else {
        TODO: can't find partial id for attribute {{ attr.id }}
      }
    } @empty {
      TODO: No attributes to edit...
    }
    @if (isCurrentChartSg()) {
      <span class="atn-summit-org-chart-node-panel-general-tab__label"
        >Resume File
      </span>
      <div class="atn-summit-org-chart-node-panel-general-tab__file-section">
        <div class="atn-summit-org-chart-node-panel-general-tab__file-button">
          <atn-ds-file
            [isUploadIcon]="true"
            [isUploading]="isUploadingFileSg()"
            [types]="['.pdf']"
            (fileChange)="onFileChange($event)"
          />
        </div>

        <div class="atn-summit-org-chart-node-panel-general-tab__file-button">
          <atn-ds-button
            [disabled]="!resumeFileSg()"
            type="transparent"
            (click)="downloadFileButtonClickHandler()"
            ><i class="atn-icon atn-download atn-blue"></i
          ></atn-ds-button>
        </div>
      </div>
    }
  </div>
}
